let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fTjh6")).then(() => parcelRequire('b2gKV'));